export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <span className="text-teal-600 font-semibold text-sm uppercase tracking-wide">About James Cleaning</span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
              Melbourne&apos;s Cleaning Team You Can Trust
            </h2>
            
            <p className="text-gray-600 leading-relaxed text-lg">
              With over <strong>10 years of experience</strong>, James Cleaning has become Melbourne&apos;s trusted choice for homeowners and businesses who demand excellence. Our tight-knit <strong>team of 5 professionals</strong> uses eco-friendly products and proven techniques to deliver spotless results every time.
            </p>

            <p className="text-gray-600 leading-relaxed text-lg">
              Based in Melbourne, we proudly service all surrounding suburbs — from Toorak and South Yarra to Doncaster, Brighton, Hawthorn, and beyond. No matter where you are, we bring the same dedication and quality to your doorstep.
            </p>

            <p className="text-gray-600 leading-relaxed text-lg">
              Our fully insured team undergoes rigorous background checks and continuous training to ensure your peace of mind. We&apos;re not just cleaning homes — we&apos;re building lasting relationships with our Melbourne community.
            </p>

            <div className="grid grid-cols-3 gap-6 pt-6">
              <div>
                <div className="text-4xl font-bold text-teal-600 mb-2">2,000+</div>
                <p className="text-gray-600 font-medium">Happy Clients</p>
              </div>
              <div>
                <div className="text-4xl font-bold text-teal-600 mb-2">50+</div>
                <p className="text-gray-600 font-medium">Suburbs Covered</p>
              </div>
              <div>
                <div className="text-4xl font-bold text-teal-600 mb-2">10</div>
                <p className="text-gray-600 font-medium">Years Experience</p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/f59db822b8c88762aee7c9399a87ba88.jpg"
                alt="James Cleaning Team"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="absolute -bottom-6 -left-6 bg-teal-600 text-white rounded-2xl p-6 shadow-xl">
              <div className="text-4xl font-bold mb-1">10 Years</div>
              <p className="font-medium">Serving Melbourne</p>
            </div>

            <div className="absolute -top-6 -right-6 bg-white rounded-2xl p-6 shadow-xl">
              <div className="flex items-center gap-2 mb-2">
                <i className="ri-team-line text-3xl text-teal-600"></i>
              </div>
              <p className="font-bold text-gray-900">Team of 5</p>
              <p className="text-sm text-gray-600">Expert Professionals</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
